import { GetItemsProps } from "medere-ui-framework";
import { axiosInstance } from "../../App";
import { Establishment, Office, Sector, Totem, Box, PatientCaller, Room, Bed } from "../../interface/interface";

export function loadAllEstablishments(): Promise<Establishment[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadAllEstablishments', {
        params: {

        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export async function inactivateEstablishment(buildingId: number): Promise<void> {
    await axiosInstance.post("/api/secured/locationconfigcontroller/inactivateEstablishment", null, {
        params: { id: buildingId }
    });
}

export async function activateEstablishment(buildingId: number): Promise<void> {
  await axiosInstance.post("/api/secured/locationconfigcontroller/activateEstablishment", null, {
    params: { id: buildingId }
  });
}


export function loadSectorsByBuildingId(params: {buildingid:number}): Promise<Sector[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadSectorsByBuildingId', {
        params: {
            buildingid: params.buildingid
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function getSectorTypes(buildingid: number) {
  return axiosInstance.get("/api/secured/locationconfigcontroller/getSectorTypesByBuildingId", {
    params: { buildingid }
  })
  .then(res => res.data.map((s: any) => ({
    id: s.sectortype,
    description: s.sectortypedescription
  })))
  .catch(err => {
    console.error("Error al cargar tipos de sector", err);
    return [];
  });
}

export function getRepositoryTypes(buildingid: number) {
  return axiosInstance.get("/api/secured/locationconfigcontroller/getRepositoryTypesByBuildingId", {
    params: { buildingid }
  })
  .then(res => res.data.map((r: any) => ({ id: r.repositorytype, description: r.repositorytypedescription })))
  .catch(err => {
    console.error("Error cargando tipos de repositorio", err);
    return [];
  });
}

export function getWorkingRepositories(buildingid: number, repositorytype: number) {
  return axiosInstance.get("/api/secured/locationconfigcontroller/getWorkingRepositoriesByBuildingAndRepositoryType", {
    params: { buildingid, repositorytype }
  })
  .then(res => res.data.map((r: any) => ({ id: r.sector, description: r.name })))
  .catch(err => {
    console.error("Error cargando repositorios de trabajo", err);
    return [];
  });
}

export function loadOfficesByBuildingId(params: {buildingid:number}): Promise<Office[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadOfficesByBuildingId', {
        params: {
            buildingid: params.buildingid
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function saveOffice(office: Office): Promise<Office> {
  try {
    const payload = {
      ...office,
      hospitallocation: office.hospitallocation <= 0 ? null : office.hospitallocation
    };
    return axiosInstance.post("/api/secured/locationconfigcontroller/saveOffice", payload);
    } catch (error: any) {
    console.error("Error al guardar consultorio", error?.response?.data || error);
    throw error;
  }
}

export async function inactivateOffice(id: number): Promise<void> {
  await axiosInstance.post("/api/secured/locationconfigcontroller/deactivateOffice", null, {
    params: { id }
  });
}

export async function activateOffice(id: number): Promise<void> {
  await axiosInstance.post("/api/secured/locationconfigcontroller/activateOffice", null, {
    params: { id }
  });
}

export function loadBoxesByBuildingId(params: {buildingid:number}): Promise<Box[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadBoxesByBuildingId', {
        params: {
            buildingid: params.buildingid
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function loadRoomsByBuildingId(params: {buildingid:number}): Promise<Room[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadRoomsByBuildingId', {
        params: {
            buildingid: params.buildingid
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function loadBedsByBuildingId(params: {buildingid:number}): Promise<Bed[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadBedsByBuildingId', {
        params: {
            buildingid: params.buildingid
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function loadRoomsBySectorId(params: {sectorid:number}): Promise<Room[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadRoomsBySectorId', {
        params: {
            sectorid: params.sectorid
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function getAllHospitalLocationBySectorId({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get('/api/secured/locationconfigcontroller/getAllHospitalLocationBySectorId',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??'',
            sectorId: params.sectorId,
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function loadPatientCallers(): Promise<PatientCaller[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadPatientCallers', {
        params: {
            
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function loadTotems(): Promise<Totem[]> {
    return axiosInstance.get('/api/secured/locationconfigcontroller/loadTotems', {
        params: {
            
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function getMedicalScheduleTemplateForTotem({filterValue,offSet,pageSize}:GetItemsProps){
    return axiosInstance.get('/api/secured/locationconfigcontroller/getMedicalScheduleTemplateForTotem',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??'',
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getLocationTypes({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get('/api/secured/locationconfigcontroller/getLocationTypes',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??'',
            onlyOffices: params.onlyOffices,
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getHealthServices({filterValue,offSet,pageSize}:GetItemsProps){
    return axiosInstance.get('/api/secured/locationconfigcontroller/getHealthServices',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??'',
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getMonitorTypes({filterValue,offSet,pageSize}:GetItemsProps){
    return axiosInstance.get('/api/secured/locationconfigcontroller/getMonitorTypes',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??'',
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function inactivateSector(sectorId: number) {
  axiosInstance.post("/api/secured/locationconfigcontroller/inactivateSector?sectorId=" + sectorId);
}

export function activateSector(sectorId: number, active: boolean) {
  return axiosInstance.post(`/api/secured/locationconfigcontroller/activateSector`, null, {
    params: { sectorId, active }
  });
}

export async function saveSector(sector: Sector) {
  try {
    return await axiosInstance.post("/api/secured/locationconfigcontroller/saveSector", sector)
    .then(response => response.data);
  } catch (error: any) {
    console.error("Error al guardar sector", error?.response?.data || error);
    throw error;
  }
}

export async function saveEstablishment(establishment: Establishment): Promise<Establishment> {
  const payload = {
    ...establishment,
    buildingid: establishment.buildingid <= 0 ? null : establishment.buildingid
  };
  const res = await axiosInstance.post("/api/secured/locationconfigcontroller/saveEstablishment", payload);
  return res.data;
}

export async function deleteEstablishment(id: number) {
  return await axiosInstance.delete(`/api/secured/locationconfigcontroller/deleteEstablishment?id=${id}`)
  .then(response => response.data);
}

export function saveHospitalLocation(data: Box) {
  return axiosInstance.post('/api/secured/locationconfigcontroller/saveHospitalLocation', data)
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function saveRoom(data: Room) {
  return axiosInstance.post('/api/secured/locationconfigcontroller/saveRoom', data)
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function saveBed(data: Bed) {
  return axiosInstance.post('/api/secured/locationconfigcontroller/saveBed', data)
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function removeHospitalLocation(hospitalLocationId: number) {
  return axiosInstance.delete(`/api/secured/locationconfigcontroller/removeHospitalLocation`, {
    params: {
      hospitalLocationId: hospitalLocationId
    }
  }).then(response => response.data);
}

export function savePatientCaller(data: PatientCaller) {
  return axiosInstance.post('/api/secured/locationconfigcontroller/savePatientCaller', data)
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function saveTotem(data: Totem) {
  return axiosInstance.post('/api/secured/locationconfigcontroller/saveTotem', data)
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function getAllSectorTypes() {
  return axiosInstance.get("/api/secured/locationconfigcontroller/getAllSectorTypes")
    .then(res => res.data.map((s: any) => ({
      id: s.sectortype,
      description: s.sectortypedescription
    })))
    .catch(err => {
      console.error("Error cargando tipos de sector", err);
      return [];
    });
}

export function getAllRepositoryTypes() {
  return axiosInstance.get("/api/secured/locationconfigcontroller/getAllRepositoryTypes")
    .then(res => res.data.map((r: any) => ({
      id: r.repositorytype,
      description: r.description
    })))
    .catch(err => {
      console.error("Error cargando tipos de repositorio", err);
      return [];  
    });
}

export function associateBoxToHardware(params: {hospitalLocationId: number, uuid: string}) {
  return axiosInstance.get('/api/secured/locationconfigcontroller/associateBoxToHardware', {
    params: {
      hospitalLocationId: params.hospitalLocationId,
      uuid: params.uuid,
    }
  })
  .then(response => response.data)
  .catch(error => {
    console.error(error);
    throw error;
  });
}

export function deassociateBoxFromHardware(params: {hospitalLocationId: number}) {
  return axiosInstance.get('/api/secured/locationconfigcontroller/deassociateBoxFromHardware', {
    params: {
      hospitalLocationId: params.hospitalLocationId
    }
  })
  .then(response => response.data)
  .catch(error => {
    console.error(error);
    throw error;
  });
}

export function hasActiveAssociatedDeviceToHospitalLocation(uuid: string) {
  return axiosInstance.get('/api/secured/locationconfigcontroller/hasActiveAssociatedDeviceToHospitalLocation', {
    params: {
      uuid: uuid,
    }
  })
  .then(response => response.data)
  .catch(error => {
    console.error(error);
    throw error;
  });
}

export function removePatientCaller(patientCallerId: number) {
  return axiosInstance.delete(`/api/secured/locationconfigcontroller/removePatientCaller`, {
    params: {
      patientCallerId: patientCallerId
    }
  }).then(response => response.data);
}

export function resetAllNumberCallers() {
  return axiosInstance.get('/api/public/patientcallercontroller/resetAllNumberCallers')
    .then(response => response.data)
    .catch(error => {
      console.error('Error reseteando numeradores de llamadores', error);
      throw error;
    });
}

export function removeTotem(totemId: number) {
  return axiosInstance.delete(`/api/secured/locationconfigcontroller/removeTotem`, {
    params: {
      totemId: totemId
    }
  }).then(response => response.data);
}

export async function deleteSector(sectorId: number) {
  await axiosInstance.delete("/api/secured/locationconfigcontroller/deleteSector", {
    params: { sectorId }
  })
  .then(response => response.data)
  .catch(error => {
    console.error("Error al eliminar sector", error);
    throw error;
  });
}

export async function deleteRoom(roomId: number) {
  await axiosInstance.delete("/api/secured/locationconfigcontroller/deleteRoom", {
    params: { roomId }
  })
  .then(response => response.data)
  .catch(error => {
    console.error("Error al eliminar habitación", error);
    throw error;
  });
}

export async function deleteBed(bedId: number) {
  await axiosInstance.delete("/api/secured/locationconfigcontroller/deleteBed", {
    params: { bedId }
  })
  .then(response => response.data)
  .catch(error => {
    console.error("Error al eliminar cama", error);
    throw error;
  });
}

export function getHospitalLocationIdByHardwareId() {
  return axiosInstance.get('/api/secured/locationconfigcontroller/getHospitalLocationIdByHardwareId', {
    params: {
      hardwareId: localStorage.getItem('uuid') || '',
    }
  })
  .then(response => response.data)
  .catch(error => {
    console.error(error);
    throw error;
  });
}

export function useLocationConfigService() {
  return {
    loadAllEstablishments,
    inactivateEstablishment,
    activateEstablishment,
    loadSectorsByBuildingId,
    getSectorTypes,
    getRepositoryTypes,
    getWorkingRepositories,
    loadOfficesByBuildingId,
    saveOffice,
    inactivateOffice,
    activateOffice,
    loadBoxesByBuildingId,
    loadRoomsByBuildingId,
    loadBedsByBuildingId,
    loadRoomsBySectorId,
    getAllHospitalLocationBySectorId,
    loadPatientCallers,
    loadTotems,
    getMedicalScheduleTemplateForTotem,
    getLocationTypes,
    getHealthServices,
    getMonitorTypes,
    inactivateSector,
    activateSector,
    saveSector,
    saveEstablishment,
    deleteEstablishment,
    saveHospitalLocation,
    saveRoom,
    saveBed,
    removeHospitalLocation,
    savePatientCaller,
    saveTotem,
    getAllSectorTypes,
    getAllRepositoryTypes,
    associateBoxToHardware,
    deassociateBoxFromHardware,
    hasActiveAssociatedDeviceToHospitalLocation,
    removePatientCaller,
    resetAllNumberCallers,
    removeTotem,
    deleteSector,
    deleteRoom,
    deleteBed,
    getHospitalLocationIdByHardwareId,
  }
}
